import { render, staticRenderFns } from "./consumable.vue?vue&type=template&id=12bd3522&"
import script from "./consumable.vue?vue&type=script&lang=js&"
export * from "./consumable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports